import { Component, OnInit, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-display-field',
  templateUrl: './display-field.component.html',
  styleUrls: ['./display-field.component.scss'],
  host: { '[class]': 'widthClass' }
})
export class DisplayFieldComponent implements OnInit {
  @Input() label:string;
  @Input() value:any;
  @Input() widths:any;
  @Input() fdef:any;
  @Input() widthClass:string;
  constructor() { }

  ngOnInit() {


    if(!this.widths){
      this.widths = {
        "xs":12,
        "sm":12,
        "md":4,
        "lg":2
      }
    }

    if(!this.widthClass){
      let wClasses : string[] = [];
      for(let i in this.widths){
        if(this.widths[i]){
          wClasses.push("col-" + i + "-" + this.widths[i]);
        }else{
          wClasses.push("col-" + i);
        }

      }
      this.widthClass = wClasses.join(" ");
    }

    if (!this.fdef) {
      this.fdef = "default";
    }

    if(this.fdef){
      switch (this.fdef.fieldtype) {
        case "select":
        case "gender":
          if(this.value instanceof Object  && this.value.value){
            this.value = this.value.value;
          }

          this.value = this.fdef.prepOptions[this.value];
          break;
        case "checkbox":
          if(this.value){
            this.value = "Oui";
          }else{
            this.value = "Non";
          }
          break;
        case "datetime":
          let datePipe2 = new DatePipe("fr-FR");
          if(this.value && this.value.toString().length == "10"){
            this.value = this.value*1000;
          }
          this.value = datePipe2.transform(this.value, 'dd/MM/y H:mm');
          break;
        case "date":
          let datePipe = new DatePipe("fr-FR");
          if(this.value && this.value.toString().length == "10"){
            this.value = this.value*1000;
          }
          this.value = datePipe.transform(this.value, 'dd/MM/y');
        break;
      }
    }
    this.widthClass += " display-field";
  }

}
